/**
 * Complete Quiz Task API
 *
 * Records the learner's quiz score on a quiz item so the ProgressionEngine
 * resolves the pass/fail score-mode conditional edges. Grading itself happens
 * via the quiz-attempt endpoints; this records the resulting score (0..100)
 * into the learning-path completion funnel.
 * POST /api/path-items/{itemId}/complete-quiz-task
 */

import axiosInstance from "../axiosInstance";

export interface CompleteQuizTaskRequest {
  enrollmentId: number;
  /** Score 0..100. A failing score still completes the item; branches route pass/fail. */
  score: number;
}

export interface CompleteQuizTaskResponse {
  completed: boolean;
  completedAt: string;
  score: number;
  passed: boolean;
  alreadyCompleted: boolean;
  pathProgress: {
    percentage: number;
    pathComplete: boolean;
  };
}

export const completeQuizTask = async (
  pathItemId: number,
  request: CompleteQuizTaskRequest,
): Promise<CompleteQuizTaskResponse> => {
  const response = await axiosInstance.post<CompleteQuizTaskResponse>(
    `/api/path-items/${pathItemId}/complete-quiz-task`,
    request,
  );

  return response.data;
};
